module.exports = __webpack_public_path__ + "img/analyze.6ec2bd9c.svg";